// extracted by mini-css-extract-plugin
export default {"content":"FeedToken_content__RlEe4","description":"FeedToken_description__IO2WB"};